import { useNavigate } from "react-router-dom";
import ContainerComponent from "../../../components/conatiner";
import HeaderComponent from "../../../components/header";
import { ChangeEvent, useEffect, useState } from "react";
import CardHeaderBackgroundComponent from "../../../components/cardHeaderBackground";
import InputComponent from "../../../components/input";
import { Autocomplete, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { ManagersOrdersService, ManagersUpdateCostCenterService, ManagersOrdersExport } from "../../../services/managers/orders";
import { ToastErro, ToastSucesso } from "../../../components/toast";
import { ManagersAllCostCentersService } from "../../../services/managers/cost_centers";
import LoadingComponent from "../../../components/loading";
import TableComponent from "../../../components/table";
import moment from "moment";
import ModalComponent from "../../../components/modal";
import { urlMobile } from "../../../services";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import axios from 'axios';
import BusinessCardBadgeComponent, { isBusinessCard } from "../../../components/businessCardBadge";

const ManagersOrdersPage = () => {

    const navigate = useNavigate();

    const [loadingOrders, setLoadingOrders] = useState<boolean>(true);
    const [loadingExports, setloadingExports] = useState<boolean>(true);
    const [loadingCostCenters, setLoadingCostCenters] = useState<boolean>(true);

    const [orders, setOrders] = useState<any>([]);

    const [costCenters, setCostCenters] = useState<any>([]);

    // variaveis de pesquisa
    const [nameUser, setNameUser] = useState<string>("");
    const [number, setNumber] = useState<number>(null!);
    const [costCenter, setCostCenter] = useState<number>(null!);
    const [date, setDate] = useState<string>(null!);
    const [status, setStatus] = useState<number>(null!);
    const [page, setPage] = useState<number>(1);

    // variaveis para export
    const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName = "RDI-EXPORT-ITENS-" + moment(new Date()).format('DD-MM-YYYY');
    const [exports, setExport] = useState<any>([]);

    const [editCostCenter, setEditCostCenter] = useState<any>(null);

    // função para pesquisar as ordens
    const getOrders = async () => {

        setLoadingOrders(true);

        await ManagersOrdersService(number, costCenter, date, status, page, nameUser).then(resp => {
            setOrders(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoadingOrders(false);

    }

    // função para exportar as ordens
    const exportOrders = async () => {

        //esse ManagersOrdersExport é o componente com a rota axios 
        await ManagersOrdersExport(number, costCenter, date, status).then(resp => {

            //variavel para formatação dos dados
            let dataFormat: any = [];

            resp.data.map((l: any, i: number) => {
                dataFormat.push({
                    "Nº da Ordem": l.Ordem,
                    "Nº do Item": l.Item,
                    "Usuário": l.Usuario,
                    "Categoria": l.Categoria,
                    "Centro de Custo": l.costCenter,
                    "Status": l.Status,
                    "Descrição": l.Descricao,
                    "Data": l.Data,
                    "Valor": l.Valor,
                    "UF": l.UF,
                    "Cidade": l.Cidade,
                    "Kilometragem": l.mileage,
                    "Modelo": l.Model,
                    "Placa": l.Placa,
                    "Qtd": l.Qtd,
                    "Cartão Corporativo": isBusinessCard(l.CartaoCorporativo) ? 'Sim' : 'Não',
                    //"Imagem": urlMobile.replaceAll('api/', 'storage') + l.Arquivo,
                })
            })

            setloadingExports(true);

            const ws = XLSX.utils.json_to_sheet(dataFormat);
            //const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
            var wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, ws, 'RDI')
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);

            setloadingExports(false);


            //setExport(dataFormat);

        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });
    }

    // função para pesquisar os centros de custo
    const getCostCenters = async () => {

        setLoadingCostCenters(true);

        await ManagersAllCostCentersService().then(resp => {
            console.log(resp.data);
            setCostCenters(resp.data);
        }).catch(error => {
            ToastErro(error?.response?.data?.message);
        });

        setLoadingCostCenters(false);

    }
    // função para pesquisar os centros de custo

    // função para editar centro de custo
    const updateCostCenter = async (id: number) => {

        (window as any).$("#modalEditCostCenter" + id).modal("hide");

        setLoadingOrders(true);

        await ManagersUpdateCostCenterService(id, editCostCenter.id).then(resp => {
            ToastSucesso(resp.data.message);
            getOrders();
        }).catch(error => {
            setLoadingOrders(false);
            ToastErro('Ocorreu um erro ao tentar alterar o centro de custo!');
        });

    }
    // função para editar centro de custo

    useEffect(() => {
        getOrders();
    }, [page]);

    useEffect(() => {
        getCostCenters();
    }, []);


    return (
        <>
            <HeaderComponent
                title="Ordens"
                button="Exportar"
                iconButton=""
                onClick={() => exportOrders()}

            />
            <ContainerComponent>
                <>
                    <CardHeaderBackgroundComponent
                        title="Pesquisar"
                    >
                        {
                            loadingCostCenters

                                ?

                                <LoadingComponent />

                                :

                                <>
                                    <div className="row">
                                        <InputComponent
                                            label="Nome Usuário"
                                            col={12}
                                            size={"small"}
                                            defaultValue={nameUser}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => setNameUser(e.target.value)}
                                            type="text"
                                        />
                                        <InputComponent
                                            label="N° da Ordem"
                                            col={4}
                                            size={"small"}
                                            defaultValue={number}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => setNumber(parseInt(e.target.value))}
                                            type={'number'}
                                        />
                                        <InputComponent
                                            label="Data de Cadstro"
                                            col={4}
                                            size={"small"}
                                            type={'date'}
                                            defaultValue={date}
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => setDate(e.target.value)}
                                            shrink
                                        />
                                        <div className="col-md-4 mb-4">
                                            <FormControl
                                                fullWidth
                                                size="small"
                                            >
                                                <InputLabel>Status</InputLabel>
                                                <Select
                                                    label="Status"
                                                    value={status}
                                                    onChange={(e: any) => setStatus(e.target.value)}
                                                >
                                                    <MenuItem value={2}>Pago</MenuItem>
                                                    <MenuItem value={3}>Pendente de Aprovação</MenuItem>
                                                    <MenuItem value={7}>Pendnete de Pagamento</MenuItem>
                                                    <MenuItem value={4}>Reprovado</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-8 mb-4">
                                            <FormControl
                                                fullWidth
                                                size="small"
                                            >
                                                <InputLabel>Centro de Custo</InputLabel>
                                                <Select
                                                    label="Centro de Custo"
                                                    value={costCenter}
                                                    onChange={(e: any) => setCostCenter(e.target.value)}
                                                >
                                                    {
                                                        costCenters.map((c: any) => {
                                                            return <MenuItem key={c.id} value={c.id}>{c.description}</MenuItem>;
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </div>
                                        <div className="col-md-4">
                                            <button className="btn btn-primary" type="button" onClick={() => page > 1 ? setPage(1) : getOrders()}>Pesquisar</button>
                                            <button className="btn btn-danger" type="button" style={{ marginLeft: 15 }} onClick={() => (window as any).location.reload()}>Limpar</button>
                                        </div>
                                    </div>
                                </>
                        }
                    </CardHeaderBackgroundComponent>

                    <TableComponent
                        title="Ordens"
                        columns={['Nº da Ordem', 'Data de Cadastrdo', 'Usuário', 'Centro de Custo', 'Status', 'Nível de Aprovação', 'Qtd. de Níveis', 'Cartão Corporativo', 'Informações']}
                        loading={loadingOrders}
                        page={page}
                        last_page={orders?.last_page}
                        onClickPagination={(e: ChangeEvent<unknown>, value: number) => setPage(value)}
                    >
                        {
                            orders?.data?.map((o: any) => {
                                return (
                                    <tr key={o.id}>
                                        <td className="px-4">{o.id}</td>
                                        <td className="px-4">{moment(o.created_at).format('DD/MM/YYYY')}</td>
                                        <td className="px-4">{o.name}</td>
                                        <td className="px-4">{o.cost_center}</td>
                                        <td className="px-4">
                                            {
                                                o.status == 'Aprovado'

                                                    ?

                                                    <h6><span className="badge bg-info">{o.status}</span></h6>

                                                    :

                                                    o.status == 'Pago'

                                                        ?

                                                        <h6><span className="badge bg-success">{o.status}</span></h6>

                                                        :

                                                        o.status == 'Pendente de Aprovação'

                                                            ?

                                                            <h6><span className="badge bg-warning">{o.status}</span></h6>

                                                            :

                                                            o.status == 'Pendente de Pagamento'

                                                                ?

                                                                <h6><span className="badge bg-info">{o.status}</span></h6>

                                                                :

                                                                <h6><span className="badge bg-danger">{o.status}</span></h6>
                                            }
                                        </td>
                                        <td className="px-4">
                                            {
                                                o.level <= o.approval_levels && o.status == 'Pendente de Aprovação'

                                                    ?

                                                    o.level

                                                    :

                                                    'Finalizado'
                                            }
                                        </td>
                                        <td className="px-4">{o.approval_levels}</td>
                                        <td className="px-4">
                                            <BusinessCardBadgeComponent value={o.payment_business_card} />
                                        </td>
                                        <td className="px-4">
                                            {
                                                o.status == 'Pendente de Aprovação' && o.level == 1 &&

                                                <>
                                                    <button className="btn btn-text-warning" type="button" title="Editar Centro de Custo" onClick={() => {
                                                        (window as any).$("#modalEditCostCenter" + o.id).modal("show");
                                                        setEditCostCenter({ id: o.cost_center_id, description: o.cost_center, code: o.code })
                                                    }}><i className="material-icons">edit</i></button>

                                                    <ModalComponent
                                                        title="Editar Centro de Custo"
                                                        id={`modalEditCostCenter${o.id}`}
                                                    >
                                                        <>
                                                            <div className="row mt-3">
                                                                <div className="col-md-12">
                                                                    <Autocomplete
                                                                        options={costCenters}
                                                                        sx={{ width: 300 }}
                                                                        className="w-100"
                                                                        renderInput={(params) => <TextField {...params} label="Centro de Custo" />}
                                                                        getOptionLabel={(option: any) => option.code + ' - ' + option.description}
                                                                        value={editCostCenter}
                                                                        onChange={(event: any, newValue) => setEditCostCenter(newValue)}
                                                                        isOptionEqualToValue={(option: any, value: any) => option.id == value.id}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-end mt-4">
                                                                <button className="btn btn-primary" type="button" onClick={() => updateCostCenter(o.id)}>Salvar</button>
                                                            </div>
                                                        </>
                                                    </ModalComponent>
                                                </>
                                            }
                                            <button className="btn btn-text-info" type="button" title="Informações" onClick={() => navigate(`/managers/orders/${o.id}`)}><i className="material-icons">info</i></button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                    </TableComponent>
                </>
            </ContainerComponent>
        </>
    )

}

export default ManagersOrdersPage;